import React, { useEffect, useState } from "react";
import "./CreateJob.scss";

import { connect } from "react-redux";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import moment from "moment";

import axios from "axios";

import { useNavigate } from "react-router-dom";

import { updateUserFromCreateJob } from "../../state/action-creators";

import {
  useToast,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  FormHelperText,
  Menu,
  Button,
  MenuButton,
  MenuList,
  MenuItem,
  Textarea,
} from "@chakra-ui/react";

import {
  ChevronLeftIcon,
  ChevronDownIcon,
  AddIcon,
  EditIcon,
} from "@chakra-ui/icons";

const CREATE_NEW_JOB = "To create new job, please fill the below details";
const EDIT_JOB_TEXT = "To edit job, please update below details";

const PLACEHOLDER_TEXT = {
  TITLE: "Enter title for the job",
  LOCATION: "Enter location of job",
  POSITION: "Enter no. of position to fill",
  START_DATE: "Enter start date for job",
  END_DATE: "Enter start date for job",
};

const ERROR_TEXT = {
  TITLE: "Title is required.",
  LOCATION: "Location in required.",
  POSITION: "No. of position id required.",
  START_DATE: "Start date is not valid date.",
  END_DATE: "End date is not valid date.",
  RESPONSIBILITY: "Responsibility is required.",
  SKILLS: "SKills is required.",
};

const HELPER_TEXT = {
  START_DATE: "[Date format: DD/MM/YYYY or DD-MM-YYYY]",
  END_DATE: "[Date format: DD/MM/YYYY or DD-MM-YYYY]",
};

const JOB_TYPE_ENUM = ["Internship", "Fulltime", "Parttime", "Contract"];
const JOB_STATUS_ENUM = ["Open", "Close", "Freeze"];

const CreateJob = (props) => {
  const { selectedJob, isEditMode, updateUserFromCreateJob } = props;

  const [title, setTitle] = useState("");
  const [isTitleNotValid, setIsTitleNotValid] = useState(false);
  const [location, setLocation] = useState("");
  const [isLocationNotValid, setIsLocationNotValid] = useState(false);
  const [position, setPosition] = useState("");
  const [isPositionNotValid, setIsPositionNotValid] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [isStartDateNotValid, setIsStartDateNotValid] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [isEndDateNotValid, setIsEndDateNotValid] = useState(false);
  const [jobType, setJobType] = useState("Fulltime");
  const [jobStatus, setJobStatus] = useState("Open");
  const [description, setDescription] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [isResponsibilityNotValid, setIsResponsibilityNotValid] =
    useState(false);
  const [skill, setSkills] = useState("");
  const [isSkillsNotValid, setIsSkillsNotValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (selectedJob) {
      setTitle(selectedJob?.title);
      setLocation(selectedJob?.location);
      setPosition(selectedJob?.position);
      setStartDate(moment(selectedJob?.startDate).format("DD-MM-YYYY"));
      setEndDate(moment(selectedJob?.endDate).format("DD-MM-YYYY"));
      setJobType(selectedJob?.jobType);
      setJobStatus(selectedJob?.jobStatus);
      setDescription(selectedJob?.description);
      setResponsibility(selectedJob?.responsibility);
      setSkills(selectedJob?.skill);
    }
  }, [selectedJob]);

  useEffect(() => {
    updateUserFromCreateJob(true);
  }, [updateUserFromCreateJob]);

  const constResetCreateJobValues = () => {
    setTitle("");
    setLocation("");
    setPosition("");
    setStartDate("");
    setEndDate("");
    setJobType("Fulltime");
    setJobStatus("Open");
    setDescription("");
    setResponsibility("");
    setSkills("");
  };

  const handleCreateJobGoBackClick = () => {
    navigate(-1);
  };

  const renderCreateNewJobFeed = () => {
    const handleTitleChange = (e) => {
      setTitle(e?.target?.value);
    };

    const handleLocationChange = (e) => {
      setLocation(e?.target?.value);
    };

    const handlePositionChange = (e) => {
      const reg = /^\d+$/;

      if (e?.target?.value === "") {
        setPosition("");
      }
      if (reg.test(e?.target?.value)) {
        setPosition(e?.target?.value);
      }
    };

    const handleStartDateChange = (e) => {
      setStartDate(e?.target?.value);
    };

    const handleEndDateChange = (e) => {
      setEndDate(e?.target?.value);
    };

    const handleJobTypeChange = (e) => {
      setJobType(e?.target?.value);
    };

    const handleJobStatusChange = (e) => {
      setJobStatus(e?.target?.value);
    };

    const handleDescriptionChange = (e) => {
      setDescription(e?.target?.value);
    };

    const handleResponsibilityChange = (e, editor) => {
      const data = editor.getData();
      setResponsibility(data);
    };

    const handleSkillsChange = (e, editor) => {
      const data = editor.getData();
      setSkills(data);
    };

    const handleCreateJobClick = async () => {
      const checkIsTitleNotValid = title?.length <= 0;
      const checkIsLocationNotValid = location?.length <= 0;
      const checkIsPositionNotValid = position?.length <= 0;
      const checkIsStartDateNotValid = !moment(
        startDate,
        "DD-MM-YYYY"
      ).isValid();
      const checkIsEndDateNotValid = !moment(endDate, "DD-MM-YYYY").isValid();
      const checkIsResponsibilityNotValid = responsibility?.length <= 0;
      const checkIsSkillsNotValid = skill?.length <= 0;

      setIsTitleNotValid(checkIsTitleNotValid);
      setIsLocationNotValid(checkIsLocationNotValid);
      setIsPositionNotValid(checkIsPositionNotValid);
      setIsStartDateNotValid(checkIsStartDateNotValid);
      setIsEndDateNotValid(checkIsEndDateNotValid);
      setIsResponsibilityNotValid(checkIsResponsibilityNotValid);
      setIsSkillsNotValid(checkIsSkillsNotValid);

      if (
        !checkIsTitleNotValid &&
        !checkIsLocationNotValid &&
        !checkIsPositionNotValid &&
        !checkIsStartDateNotValid &&
        !checkIsEndDateNotValid &&
        !checkIsResponsibilityNotValid &&
        !checkIsSkillsNotValid
      ) {
        try {
          setIsLoading(true);
          const newJob = {
            title,
            location,
            position: Number(position),
            startDate,
            endDate,
            jobType,
            jobStatus,
            description,
            responsibility,
            skill,
          };
          if (isEditMode) {
            await axios.put(
              `https://workoza-server-vercel.vercel.app/api/job/${selectedJob?._id}`,
              newJob
            );
          } else {
            await axios.post(
              `https://workoza-server-vercel.vercel.app/api/job`,
              newJob
            );
          }
          toast({
            title: `Job ${isEditMode ? "updated" : "created"} successfully.`,
            status: "success",
            position: "bottom-left",
            duration: 5000,
            isClosable: true,
          });
          constResetCreateJobValues();
        } catch (e) {
          console.log(e);
        } finally {
          setIsLoading(false);
          if (isEditMode) {
            navigate(-1);
          }
        }
      }
    };

    return (
      <>
        <div className="createJobTitleContainer">
          <FormControl isRequired isInvalid={isTitleNotValid}>
            <FormLabel>Title</FormLabel>
            <Input
              type="email"
              placeholder={PLACEHOLDER_TEXT.TITLE}
              focusBorderColor="#717171"
              value={title}
              onChange={handleTitleChange}
            />
            <FormErrorMessage>{ERROR_TEXT.TITLE}</FormErrorMessage>
          </FormControl>
        </div>
        <div className="createJobLocationPositionContainer">
          <div className="createJobHalfInputContainer">
            <FormControl isRequired isInvalid={isLocationNotValid}>
              <FormLabel>Location</FormLabel>
              <Input
                type="text"
                placeholder={PLACEHOLDER_TEXT.LOCATION}
                focusBorderColor="#717171"
                value={location}
                onChange={handleLocationChange}
              />
              <FormErrorMessage>{ERROR_TEXT.LOCATION}</FormErrorMessage>
            </FormControl>
          </div>
          <div className="createJobHalfInputContainer">
            <FormControl isRequired isInvalid={isPositionNotValid}>
              <FormLabel>Position to fill</FormLabel>
              <Input
                type="text"
                placeholder={PLACEHOLDER_TEXT.POSITION}
                focusBorderColor="#717171"
                value={position}
                onChange={handlePositionChange}
              />
              <FormErrorMessage>{ERROR_TEXT.POSITION}</FormErrorMessage>
            </FormControl>
          </div>
        </div>
        <div className="createJobDateContainer">
          <div className="createJobHalfInputContainer">
            <FormControl isRequired isInvalid={isStartDateNotValid}>
              <FormLabel>Job start date</FormLabel>
              <Input
                type="text"
                placeholder={PLACEHOLDER_TEXT.START_DATE}
                focusBorderColor="#717171"
                value={startDate}
                onChange={handleStartDateChange}
              />
              <FormErrorMessage>{ERROR_TEXT.START_DATE}</FormErrorMessage>
              <FormHelperText>{HELPER_TEXT.START_DATE}</FormHelperText>
            </FormControl>
          </div>
          <div className="createJobHalfInputContainer">
            <FormControl isRequired isInvalid={isEndDateNotValid}>
              <FormLabel>Job end date</FormLabel>
              <Input
                type="text"
                placeholder={PLACEHOLDER_TEXT.END_DATE}
                focusBorderColor="#717171"
                value={endDate}
                onChange={handleEndDateChange}
              />
              <FormErrorMessage>{ERROR_TEXT.END_DATE}</FormErrorMessage>
              <FormHelperText>{HELPER_TEXT.END_DATE}</FormHelperText>
            </FormControl>
          </div>
        </div>
        <div className="createJobTypeStatusContainer">
          <div className="createJobHalfInputContainer">
            <FormLabel>Job type</FormLabel>
            <Menu placement="bottom" onChange={handleJobTypeChange}>
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                width="100%"
              >
                {jobType}
              </MenuButton>
              <MenuList>
                {JOB_TYPE_ENUM.map((type, index) => {
                  return (
                    <MenuItem
                      value={type}
                      onClick={handleJobTypeChange}
                      key={index}
                    >
                      {type}
                    </MenuItem>
                  );
                })}
              </MenuList>
            </Menu>
          </div>
          <div className="createJobHalfInputContainer">
            <FormLabel>Job status</FormLabel>
            <Menu placement="bottom" onChange={handleJobStatusChange}>
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                width="100%"
              >
                {jobStatus}
              </MenuButton>
              <MenuList>
                {JOB_STATUS_ENUM.map((status, index) => {
                  return (
                    <MenuItem
                      value={status}
                      onClick={handleJobStatusChange}
                      key={index}
                    >
                      {status}
                    </MenuItem>
                  );
                })}
              </MenuList>
            </Menu>
          </div>
        </div>
        <div className="createJobDescriptionContainer">
          <FormControl>
            <FormLabel>Description</FormLabel>
            <Textarea
              value={description}
              onChange={handleDescriptionChange}
              focusBorderColor="#717171"
              size="sm"
              resize={"none"}
            />
          </FormControl>
        </div>
        <div className="createJobCKEditorContainer">
          <FormControl isRequired isInvalid={isResponsibilityNotValid}>
            <FormLabel>Responsibility</FormLabel>
            <CKEditor
              editor={ClassicEditor}
              data={responsibility}
              onChange={handleResponsibilityChange}
            />
            <FormErrorMessage>{ERROR_TEXT.RESPONSIBILITY}</FormErrorMessage>
          </FormControl>
        </div>
        <div className="createJobCKEditorContainer">
          <FormControl isRequired isInvalid={isSkillsNotValid}>
            <FormLabel>Skills</FormLabel>
            <CKEditor
              editor={ClassicEditor}
              data={skill}
              onChange={handleSkillsChange}
            />
            <FormErrorMessage>{ERROR_TEXT.SKILLS}</FormErrorMessage>
          </FormControl>
        </div>
        <div className="createJobCreateButtonContainer">
          {!isLoading ? (
            <Button
              rightIcon={isEditMode ? <EditIcon /> : <AddIcon />}
              size="md"
              variant="solid"
              color="#ffffff"
              background="#d33853"
              _hover={{ background: "#af273e", color: "#f9f9f9" }}
              onClick={handleCreateJobClick}
            >
              {isEditMode ? "Edit" : "Create"}
            </Button>
          ) : (
            <Button isLoading background="#d33853">
              Create
            </Button>
          )}
        </div>
      </>
    );
  };

  return (
    <div className="createJobContainer">
      <div className="createJobWrapper">
        <div className="createJobGoBackContainer">
          <Button
            leftIcon={<ChevronLeftIcon w={6} h={6} />}
            size="md"
            variant="link"
            onClick={handleCreateJobGoBackClick}
          >
            Go back
          </Button>
        </div>
        <div className="createNewJobText">
          {isEditMode ? EDIT_JOB_TEXT : CREATE_NEW_JOB}
        </div>
        <div className="createJobFeedContainer">{renderCreateNewJobFeed()}</div>
      </div>
    </div>
  );
};

const mapActionCreators = {
  updateUserFromCreateJob,
};

const mapStateToProps = (state) => {
  const selectedJob = state?.navbarStateChangeReducer?.selectedJob;
  const isEditMode = selectedJob ? true : false;

  return {
    selectedJob,
    isEditMode,
  };
};

export default connect(mapStateToProps, mapActionCreators)(CreateJob);
